import { styled } from "@mui/material";
import { Link } from "react-router-dom";

export const LinkNoDecoration = styled(Link)({
    textDecoration: "none",
    color: "inherit",
});
